/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddQuizQuestionBody } from '../models';
// @ts-ignore
import type { CreateQuizBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExtendQuizDeadlineBody } from '../models';
// @ts-ignore
import type { GenerationJobResponse } from '../models';
// @ts-ignore
import type { GetAllQuizzesResponse } from '../models';
// @ts-ignore
import type { GetAllTopicsResponse } from '../models';
// @ts-ignore
import type { GetLanguagesResponse } from '../models';
// @ts-ignore
import type { GetQuizResponse } from '../models';
// @ts-ignore
import type { PublishQuizBody } from '../models';
// @ts-ignore
import type { QuizAuditResponse } from '../models';
// @ts-ignore
import type { QuizChatBody } from '../models';
// @ts-ignore
import type { QuizOwnerChoicesResponse } from '../models';
// @ts-ignore
import type { QuizPlanBody } from '../models';
// @ts-ignore
import type { QuizQuestionResponse } from '../models';
// @ts-ignore
import type { QuizSolutionCheckBody } from '../models';
// @ts-ignore
import type { QuizTopicResponse } from '../models';
// @ts-ignore
import type { QuizTopicsBody } from '../models';
// @ts-ignore
import type { QuizTopicsResponse } from '../models';
// @ts-ignore
import type { ReorderQuizQuestionsBody } from '../models';
// @ts-ignore
import type { StartAnalysisBody } from '../models';
// @ts-ignore
import type { StartGenerationBody } from '../models';
// @ts-ignore
import type { SubmissionResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { TransferQuizBody } from '../models';
// @ts-ignore
import type { UpdateQuizBody } from '../models';
// @ts-ignore
import type { UpdateQuizQuestionBody } from '../models';
// @ts-ignore
import type { UpdateTopicBody } from '../models';
/**
 * QuizApiApi - axios parameter creator
 */
export const QuizApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} auditId 
         * @param {string} key 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiAcceptQuizAuditFinding: async (auditId: string, key: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('quizApiAcceptQuizAuditFinding', 'auditId', auditId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('quizApiAcceptQuizAuditFinding', 'key', key)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiAcceptQuizAuditFinding', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/audit/{audit_id}/findings/{key}/accept`
                .replace('{audit_id}', encodeURIComponent(String(auditId)))
                .replace('{key}', encodeURIComponent(String(key)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {AddQuizQuestionBody} addQuizQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiAddQuestion: async (quizId: string, addQuizQuestionBody: AddQuizQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiAddQuestion', 'quizId', quizId)
            // verify required parameter 'addQuizQuestionBody' is not null or undefined
            assertParamExists('quizApiAddQuestion', 'addQuizQuestionBody', addQuizQuestionBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/questions`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addQuizQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiCancelGeneration: async (jobId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('quizApiCancelGeneration', 'jobId', jobId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiCancelGeneration', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/generate/{job_id}/cancel`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {QuizSolutionCheckBody} quizSolutionCheckBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiCheckQuizSolution: async (questionId: string, quizId: string, quizSolutionCheckBody: QuizSolutionCheckBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('quizApiCheckQuizSolution', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiCheckQuizSolution', 'quizId', quizId)
            // verify required parameter 'quizSolutionCheckBody' is not null or undefined
            assertParamExists('quizApiCheckQuizSolution', 'quizSolutionCheckBody', quizSolutionCheckBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/questions/{question_id}/solution-check`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizSolutionCheckBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuizBody} createQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiCreateQuiz: async (createQuizBody: CreateQuizBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuizBody' is not null or undefined
            assertParamExists('quizApiCreateQuiz', 'createQuizBody', createQuizBody)
            const localVarPath = `/api/v1/faculty/quizzes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuizBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiDeleteQuestion: async (questionId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('quizApiDeleteQuestion', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiDeleteQuestion', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/questions/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiDeleteQuiz: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiDeleteQuiz', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditId 
         * @param {string} key 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiDismissQuizAuditFinding: async (auditId: string, key: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('quizApiDismissQuizAuditFinding', 'auditId', auditId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('quizApiDismissQuizAuditFinding', 'key', key)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiDismissQuizAuditFinding', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/audit/{audit_id}/findings/{key}/dismiss`
                .replace('{audit_id}', encodeURIComponent(String(auditId)))
                .replace('{key}', encodeURIComponent(String(key)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {ExtendQuizDeadlineBody} extendQuizDeadlineBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiExtendQuizDeadline: async (quizId: string, extendQuizDeadlineBody: ExtendQuizDeadlineBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiExtendQuizDeadline', 'quizId', quizId)
            // verify required parameter 'extendQuizDeadlineBody' is not null or undefined
            assertParamExists('quizApiExtendQuizDeadline', 'extendQuizDeadlineBody', extendQuizDeadlineBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/extend`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendQuizDeadlineBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetGenerationJob: async (jobId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('quizApiGetGenerationJob', 'jobId', jobId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiGetGenerationJob', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/generate/{job_id}`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetQuiz: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiGetQuiz', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetQuizAudit: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiGetQuizAudit', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/audit`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetQuizSolutionCheck: async (quizId: string, submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiGetQuizSolutionCheck', 'quizId', quizId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('quizApiGetQuizSolutionCheck', 'submissionId', submissionId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/solution-checks/{submission_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)))
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiListQuizCodingLanguages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/quizzes/coding-languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [classId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {QuizApiListQuizzesStatusEnum} [status] 
         * @param {QuizApiListQuizzesTabEnum} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiListQuizzes: async (classId?: string, page?: number, pageSize?: number, search?: string, status?: QuizApiListQuizzesStatusEnum, tab?: QuizApiListQuizzesTabEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/quizzes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiListTopics: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiListTopics', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/topics`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {PublishQuizBody} publishQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiPublishQuiz: async (quizId: string, publishQuizBody: PublishQuizBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiPublishQuiz', 'quizId', quizId)
            // verify required parameter 'publishQuizBody' is not null or undefined
            assertParamExists('quizApiPublishQuiz', 'publishQuizBody', publishQuizBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/publish`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishQuizBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiQuizOwnerChoices: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiQuizOwnerChoices', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/owner-choices`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {ReorderQuizQuestionsBody} reorderQuizQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiReorderQuestions: async (quizId: string, reorderQuizQuestionsBody: ReorderQuizQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiReorderQuestions', 'quizId', quizId)
            // verify required parameter 'reorderQuizQuestionsBody' is not null or undefined
            assertParamExists('quizApiReorderQuestions', 'reorderQuizQuestionsBody', reorderQuizQuestionsBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/questions/reorder`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderQuizQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizPlanBody} quizPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiSaveQuizPlan: async (quizId: string, quizPlanBody: QuizPlanBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiSaveQuizPlan', 'quizId', quizId)
            // verify required parameter 'quizPlanBody' is not null or undefined
            assertParamExists('quizApiSaveQuizPlan', 'quizPlanBody', quizPlanBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/chat/plan`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizPlanBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizChatBody} quizChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiSendQuizChat: async (quizId: string, quizChatBody: QuizChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiSendQuizChat', 'quizId', quizId)
            // verify required parameter 'quizChatBody' is not null or undefined
            assertParamExists('quizApiSendQuizChat', 'quizChatBody', quizChatBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/chat`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {StartAnalysisBody} startAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiStartAnalysis: async (quizId: string, startAnalysisBody: StartAnalysisBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiStartAnalysis', 'quizId', quizId)
            // verify required parameter 'startAnalysisBody' is not null or undefined
            assertParamExists('quizApiStartAnalysis', 'startAnalysisBody', startAnalysisBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/analyze`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startAnalysisBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {StartGenerationBody} startGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiStartGeneration: async (quizId: string, startGenerationBody: StartGenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiStartGeneration', 'quizId', quizId)
            // verify required parameter 'startGenerationBody' is not null or undefined
            assertParamExists('quizApiStartGeneration', 'startGenerationBody', startGenerationBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/generate`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startGenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiStartQuizAudit: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiStartQuizAudit', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/audit`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizTopicsBody} quizTopicsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiSuggestQuizTopics: async (quizId: string, quizTopicsBody: QuizTopicsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiSuggestQuizTopics', 'quizId', quizId)
            // verify required parameter 'quizTopicsBody' is not null or undefined
            assertParamExists('quizApiSuggestQuizTopics', 'quizTopicsBody', quizTopicsBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/chat/topics`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizTopicsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {TransferQuizBody} transferQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiTransferQuiz: async (quizId: string, transferQuizBody: TransferQuizBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiTransferQuiz', 'quizId', quizId)
            // verify required parameter 'transferQuizBody' is not null or undefined
            assertParamExists('quizApiTransferQuiz', 'transferQuizBody', transferQuizBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/owner`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferQuizBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditId 
         * @param {string} key 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUndoQuizAuditFinding: async (auditId: string, key: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditId' is not null or undefined
            assertParamExists('quizApiUndoQuizAuditFinding', 'auditId', auditId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('quizApiUndoQuizAuditFinding', 'key', key)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiUndoQuizAuditFinding', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/audit/{audit_id}/findings/{key}/undo`
                .replace('{audit_id}', encodeURIComponent(String(auditId)))
                .replace('{key}', encodeURIComponent(String(key)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUndoQuizChat: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiUndoQuizChat', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/chat/undo`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {UpdateQuizQuestionBody} updateQuizQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUpdateQuestion: async (questionId: string, quizId: string, updateQuizQuestionBody: UpdateQuizQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('quizApiUpdateQuestion', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiUpdateQuestion', 'quizId', quizId)
            // verify required parameter 'updateQuizQuestionBody' is not null or undefined
            assertParamExists('quizApiUpdateQuestion', 'updateQuizQuestionBody', updateQuizQuestionBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/questions/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuizQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {UpdateQuizBody} updateQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUpdateQuiz: async (quizId: string, updateQuizBody: UpdateQuizBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiUpdateQuiz', 'quizId', quizId)
            // verify required parameter 'updateQuizBody' is not null or undefined
            assertParamExists('quizApiUpdateQuiz', 'updateQuizBody', updateQuizBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuizBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} topicId 
         * @param {UpdateTopicBody} updateTopicBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUpdateTopic: async (quizId: string, topicId: string, updateTopicBody: UpdateTopicBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizApiUpdateTopic', 'quizId', quizId)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('quizApiUpdateTopic', 'topicId', topicId)
            // verify required parameter 'updateTopicBody' is not null or undefined
            assertParamExists('quizApiUpdateTopic', 'updateTopicBody', updateTopicBody)
            const localVarPath = `/api/v1/faculty/quizzes/{quiz_id}/topics/{topic_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)))
                .replace('{topic_id}', encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTopicBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuizApiApi - functional programming interface
 */
export const QuizApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuizApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} auditId 
         * @param {string} key 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiAcceptQuizAuditFinding(auditId: string, key: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAuditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiAcceptQuizAuditFinding(auditId, key, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiAcceptQuizAuditFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {AddQuizQuestionBody} addQuizQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiAddQuestion(quizId: string, addQuizQuestionBody: AddQuizQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiAddQuestion(quizId, addQuizQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiAddQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiCancelGeneration(jobId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiCancelGeneration(jobId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiCancelGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {QuizSolutionCheckBody} quizSolutionCheckBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiCheckQuizSolution(questionId: string, quizId: string, quizSolutionCheckBody: QuizSolutionCheckBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiCheckQuizSolution(questionId, quizId, quizSolutionCheckBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiCheckQuizSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateQuizBody} createQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiCreateQuiz(createQuizBody: CreateQuizBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiCreateQuiz(createQuizBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiCreateQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiDeleteQuestion(questionId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiDeleteQuestion(questionId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiDeleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiDeleteQuiz(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiDeleteQuiz(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiDeleteQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditId 
         * @param {string} key 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiDismissQuizAuditFinding(auditId: string, key: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAuditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiDismissQuizAuditFinding(auditId, key, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiDismissQuizAuditFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {ExtendQuizDeadlineBody} extendQuizDeadlineBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiExtendQuizDeadline(quizId: string, extendQuizDeadlineBody: ExtendQuizDeadlineBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiExtendQuizDeadline(quizId, extendQuizDeadlineBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiExtendQuizDeadline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiGetGenerationJob(jobId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiGetGenerationJob(jobId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiGetGenerationJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiGetQuiz(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiGetQuiz(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiGetQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiGetQuizAudit(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAuditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiGetQuizAudit(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiGetQuizAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiGetQuizSolutionCheck(quizId: string, submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiGetQuizSolutionCheck(quizId, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiGetQuizSolutionCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiListQuizCodingLanguages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLanguagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiListQuizCodingLanguages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiListQuizCodingLanguages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [classId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {QuizApiListQuizzesStatusEnum} [status] 
         * @param {QuizApiListQuizzesTabEnum} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiListQuizzes(classId?: string, page?: number, pageSize?: number, search?: string, status?: QuizApiListQuizzesStatusEnum, tab?: QuizApiListQuizzesTabEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllQuizzesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiListQuizzes(classId, page, pageSize, search, status, tab, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiListQuizzes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiListTopics(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllTopicsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiListTopics(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiListTopics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {PublishQuizBody} publishQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiPublishQuiz(quizId: string, publishQuizBody: PublishQuizBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiPublishQuiz(quizId, publishQuizBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiPublishQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiQuizOwnerChoices(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizOwnerChoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiQuizOwnerChoices(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiQuizOwnerChoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {ReorderQuizQuestionsBody} reorderQuizQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiReorderQuestions(quizId: string, reorderQuizQuestionsBody: ReorderQuizQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiReorderQuestions(quizId, reorderQuizQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiReorderQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizPlanBody} quizPlanBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiSaveQuizPlan(quizId: string, quizPlanBody: QuizPlanBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiSaveQuizPlan(quizId, quizPlanBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiSaveQuizPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizChatBody} quizChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiSendQuizChat(quizId: string, quizChatBody: QuizChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiSendQuizChat(quizId, quizChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiSendQuizChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {StartAnalysisBody} startAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiStartAnalysis(quizId: string, startAnalysisBody: StartAnalysisBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiStartAnalysis(quizId, startAnalysisBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiStartAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {StartGenerationBody} startGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiStartGeneration(quizId: string, startGenerationBody: StartGenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerationJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiStartGeneration(quizId, startGenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiStartGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiStartQuizAudit(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAuditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiStartQuizAudit(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiStartQuizAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizTopicsBody} quizTopicsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiSuggestQuizTopics(quizId: string, quizTopicsBody: QuizTopicsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizTopicsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiSuggestQuizTopics(quizId, quizTopicsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiSuggestQuizTopics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {TransferQuizBody} transferQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiTransferQuiz(quizId: string, transferQuizBody: TransferQuizBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiTransferQuiz(quizId, transferQuizBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiTransferQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditId 
         * @param {string} key 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiUndoQuizAuditFinding(auditId: string, key: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizAuditResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiUndoQuizAuditFinding(auditId, key, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiUndoQuizAuditFinding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiUndoQuizChat(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiUndoQuizChat(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiUndoQuizChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {UpdateQuizQuestionBody} updateQuizQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiUpdateQuestion(questionId: string, quizId: string, updateQuizQuestionBody: UpdateQuizQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiUpdateQuestion(questionId, quizId, updateQuizQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiUpdateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {UpdateQuizBody} updateQuizBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiUpdateQuiz(quizId: string, updateQuizBody: UpdateQuizBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiUpdateQuiz(quizId, updateQuizBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiUpdateQuiz']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} topicId 
         * @param {UpdateTopicBody} updateTopicBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizApiUpdateTopic(quizId: string, topicId: string, updateTopicBody: UpdateTopicBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizTopicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizApiUpdateTopic(quizId, topicId, updateTopicBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizApiApi.quizApiUpdateTopic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuizApiApi - factory interface
 */
export const QuizApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuizApiApiFp(configuration)
    return {
        /**
         * 
         * @param {QuizApiApiQuizApiAcceptQuizAuditFindingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiAcceptQuizAuditFinding(requestParameters: QuizApiApiQuizApiAcceptQuizAuditFindingRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAuditResponse> {
            return localVarFp.quizApiAcceptQuizAuditFinding(requestParameters.auditId, requestParameters.key, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiAddQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiAddQuestion(requestParameters: QuizApiApiQuizApiAddQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizQuestionResponse> {
            return localVarFp.quizApiAddQuestion(requestParameters.quizId, requestParameters.addQuizQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiCancelGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiCancelGeneration(requestParameters: QuizApiApiQuizApiCancelGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerationJobResponse> {
            return localVarFp.quizApiCancelGeneration(requestParameters.jobId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiCheckQuizSolutionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiCheckQuizSolution(requestParameters: QuizApiApiQuizApiCheckQuizSolutionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.quizApiCheckQuizSolution(requestParameters.questionId, requestParameters.quizId, requestParameters.quizSolutionCheckBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiCreateQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiCreateQuiz(requestParameters: QuizApiApiQuizApiCreateQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiCreateQuiz(requestParameters.createQuizBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiDeleteQuestion(requestParameters: QuizApiApiQuizApiDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizApiDeleteQuestion(requestParameters.questionId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiDeleteQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiDeleteQuiz(requestParameters: QuizApiApiQuizApiDeleteQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizApiDeleteQuiz(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiDismissQuizAuditFindingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiDismissQuizAuditFinding(requestParameters: QuizApiApiQuizApiDismissQuizAuditFindingRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAuditResponse> {
            return localVarFp.quizApiDismissQuizAuditFinding(requestParameters.auditId, requestParameters.key, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiExtendQuizDeadlineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiExtendQuizDeadline(requestParameters: QuizApiApiQuizApiExtendQuizDeadlineRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiExtendQuizDeadline(requestParameters.quizId, requestParameters.extendQuizDeadlineBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiGetGenerationJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetGenerationJob(requestParameters: QuizApiApiQuizApiGetGenerationJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerationJobResponse> {
            return localVarFp.quizApiGetGenerationJob(requestParameters.jobId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiGetQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetQuiz(requestParameters: QuizApiApiQuizApiGetQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiGetQuiz(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiGetQuizAuditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetQuizAudit(requestParameters: QuizApiApiQuizApiGetQuizAuditRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAuditResponse> {
            return localVarFp.quizApiGetQuizAudit(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiGetQuizSolutionCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiGetQuizSolutionCheck(requestParameters: QuizApiApiQuizApiGetQuizSolutionCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionResponse> {
            return localVarFp.quizApiGetQuizSolutionCheck(requestParameters.quizId, requestParameters.submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiListQuizCodingLanguages(options?: RawAxiosRequestConfig): AxiosPromise<GetLanguagesResponse> {
            return localVarFp.quizApiListQuizCodingLanguages(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiListQuizzesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiListQuizzes(requestParameters: QuizApiApiQuizApiListQuizzesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllQuizzesResponse> {
            return localVarFp.quizApiListQuizzes(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, requestParameters.tab, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiListTopicsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiListTopics(requestParameters: QuizApiApiQuizApiListTopicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllTopicsResponse> {
            return localVarFp.quizApiListTopics(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiPublishQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiPublishQuiz(requestParameters: QuizApiApiQuizApiPublishQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiPublishQuiz(requestParameters.quizId, requestParameters.publishQuizBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiQuizOwnerChoicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiQuizOwnerChoices(requestParameters: QuizApiApiQuizApiQuizOwnerChoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizOwnerChoicesResponse> {
            return localVarFp.quizApiQuizOwnerChoices(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiReorderQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiReorderQuestions(requestParameters: QuizApiApiQuizApiReorderQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizApiReorderQuestions(requestParameters.quizId, requestParameters.reorderQuizQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiSaveQuizPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiSaveQuizPlan(requestParameters: QuizApiApiQuizApiSaveQuizPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiSaveQuizPlan(requestParameters.quizId, requestParameters.quizPlanBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiSendQuizChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiSendQuizChat(requestParameters: QuizApiApiQuizApiSendQuizChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiSendQuizChat(requestParameters.quizId, requestParameters.quizChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiStartAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiStartAnalysis(requestParameters: QuizApiApiQuizApiStartAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerationJobResponse> {
            return localVarFp.quizApiStartAnalysis(requestParameters.quizId, requestParameters.startAnalysisBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiStartGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiStartGeneration(requestParameters: QuizApiApiQuizApiStartGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerationJobResponse> {
            return localVarFp.quizApiStartGeneration(requestParameters.quizId, requestParameters.startGenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiStartQuizAuditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiStartQuizAudit(requestParameters: QuizApiApiQuizApiStartQuizAuditRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAuditResponse> {
            return localVarFp.quizApiStartQuizAudit(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiSuggestQuizTopicsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiSuggestQuizTopics(requestParameters: QuizApiApiQuizApiSuggestQuizTopicsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizTopicsResponse> {
            return localVarFp.quizApiSuggestQuizTopics(requestParameters.quizId, requestParameters.quizTopicsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiTransferQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiTransferQuiz(requestParameters: QuizApiApiQuizApiTransferQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiTransferQuiz(requestParameters.quizId, requestParameters.transferQuizBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiUndoQuizAuditFindingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUndoQuizAuditFinding(requestParameters: QuizApiApiQuizApiUndoQuizAuditFindingRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizAuditResponse> {
            return localVarFp.quizApiUndoQuizAuditFinding(requestParameters.auditId, requestParameters.key, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiUndoQuizChatRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUndoQuizChat(requestParameters: QuizApiApiQuizApiUndoQuizChatRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiUndoQuizChat(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiUpdateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUpdateQuestion(requestParameters: QuizApiApiQuizApiUpdateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizQuestionResponse> {
            return localVarFp.quizApiUpdateQuestion(requestParameters.questionId, requestParameters.quizId, requestParameters.updateQuizQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiUpdateQuizRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUpdateQuiz(requestParameters: QuizApiApiQuizApiUpdateQuizRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuizResponse> {
            return localVarFp.quizApiUpdateQuiz(requestParameters.quizId, requestParameters.updateQuizBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizApiApiQuizApiUpdateTopicRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizApiUpdateTopic(requestParameters: QuizApiApiQuizApiUpdateTopicRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizTopicResponse> {
            return localVarFp.quizApiUpdateTopic(requestParameters.quizId, requestParameters.topicId, requestParameters.updateTopicBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for quizApiAcceptQuizAuditFinding operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiAcceptQuizAuditFindingRequest {
    readonly auditId: string

    readonly key: string

    readonly quizId: string
}

/**
 * Request parameters for quizApiAddQuestion operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiAddQuestionRequest {
    readonly quizId: string

    readonly addQuizQuestionBody: AddQuizQuestionBody
}

/**
 * Request parameters for quizApiCancelGeneration operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiCancelGenerationRequest {
    readonly jobId: string

    readonly quizId: string
}

/**
 * Request parameters for quizApiCheckQuizSolution operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiCheckQuizSolutionRequest {
    readonly questionId: string

    readonly quizId: string

    readonly quizSolutionCheckBody: QuizSolutionCheckBody
}

/**
 * Request parameters for quizApiCreateQuiz operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiCreateQuizRequest {
    readonly createQuizBody: CreateQuizBody
}

/**
 * Request parameters for quizApiDeleteQuestion operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiDeleteQuestionRequest {
    readonly questionId: string

    readonly quizId: string
}

/**
 * Request parameters for quizApiDeleteQuiz operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiDeleteQuizRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiDismissQuizAuditFinding operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiDismissQuizAuditFindingRequest {
    readonly auditId: string

    readonly key: string

    readonly quizId: string
}

/**
 * Request parameters for quizApiExtendQuizDeadline operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiExtendQuizDeadlineRequest {
    readonly quizId: string

    readonly extendQuizDeadlineBody: ExtendQuizDeadlineBody
}

/**
 * Request parameters for quizApiGetGenerationJob operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiGetGenerationJobRequest {
    readonly jobId: string

    readonly quizId: string
}

/**
 * Request parameters for quizApiGetQuiz operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiGetQuizRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiGetQuizAudit operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiGetQuizAuditRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiGetQuizSolutionCheck operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiGetQuizSolutionCheckRequest {
    readonly quizId: string

    readonly submissionId: string
}

/**
 * Request parameters for quizApiListQuizzes operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiListQuizzesRequest {
    readonly classId?: string

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string

    readonly status?: QuizApiListQuizzesStatusEnum

    readonly tab?: QuizApiListQuizzesTabEnum
}

/**
 * Request parameters for quizApiListTopics operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiListTopicsRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiPublishQuiz operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiPublishQuizRequest {
    readonly quizId: string

    readonly publishQuizBody: PublishQuizBody
}

/**
 * Request parameters for quizApiQuizOwnerChoices operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiQuizOwnerChoicesRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiReorderQuestions operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiReorderQuestionsRequest {
    readonly quizId: string

    readonly reorderQuizQuestionsBody: ReorderQuizQuestionsBody
}

/**
 * Request parameters for quizApiSaveQuizPlan operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiSaveQuizPlanRequest {
    readonly quizId: string

    readonly quizPlanBody: QuizPlanBody
}

/**
 * Request parameters for quizApiSendQuizChat operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiSendQuizChatRequest {
    readonly quizId: string

    readonly quizChatBody: QuizChatBody
}

/**
 * Request parameters for quizApiStartAnalysis operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiStartAnalysisRequest {
    readonly quizId: string

    readonly startAnalysisBody: StartAnalysisBody
}

/**
 * Request parameters for quizApiStartGeneration operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiStartGenerationRequest {
    readonly quizId: string

    readonly startGenerationBody: StartGenerationBody
}

/**
 * Request parameters for quizApiStartQuizAudit operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiStartQuizAuditRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiSuggestQuizTopics operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiSuggestQuizTopicsRequest {
    readonly quizId: string

    readonly quizTopicsBody: QuizTopicsBody
}

/**
 * Request parameters for quizApiTransferQuiz operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiTransferQuizRequest {
    readonly quizId: string

    readonly transferQuizBody: TransferQuizBody
}

/**
 * Request parameters for quizApiUndoQuizAuditFinding operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiUndoQuizAuditFindingRequest {
    readonly auditId: string

    readonly key: string

    readonly quizId: string
}

/**
 * Request parameters for quizApiUndoQuizChat operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiUndoQuizChatRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizApiUpdateQuestion operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiUpdateQuestionRequest {
    readonly questionId: string

    readonly quizId: string

    readonly updateQuizQuestionBody: UpdateQuizQuestionBody
}

/**
 * Request parameters for quizApiUpdateQuiz operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiUpdateQuizRequest {
    readonly quizId: string

    readonly updateQuizBody: UpdateQuizBody
}

/**
 * Request parameters for quizApiUpdateTopic operation in QuizApiApi.
 */
export interface QuizApiApiQuizApiUpdateTopicRequest {
    readonly quizId: string

    readonly topicId: string

    readonly updateTopicBody: UpdateTopicBody
}

/**
 * QuizApiApi - object-oriented interface
 */
export class QuizApiApi extends BaseAPI {
    /**
     * 
     * @param {QuizApiApiQuizApiAcceptQuizAuditFindingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiAcceptQuizAuditFinding(requestParameters: QuizApiApiQuizApiAcceptQuizAuditFindingRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiAcceptQuizAuditFinding(requestParameters.auditId, requestParameters.key, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiAddQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiAddQuestion(requestParameters: QuizApiApiQuizApiAddQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiAddQuestion(requestParameters.quizId, requestParameters.addQuizQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiCancelGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiCancelGeneration(requestParameters: QuizApiApiQuizApiCancelGenerationRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiCancelGeneration(requestParameters.jobId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiCheckQuizSolutionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiCheckQuizSolution(requestParameters: QuizApiApiQuizApiCheckQuizSolutionRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiCheckQuizSolution(requestParameters.questionId, requestParameters.quizId, requestParameters.quizSolutionCheckBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiCreateQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiCreateQuiz(requestParameters: QuizApiApiQuizApiCreateQuizRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiCreateQuiz(requestParameters.createQuizBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiDeleteQuestion(requestParameters: QuizApiApiQuizApiDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiDeleteQuestion(requestParameters.questionId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiDeleteQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiDeleteQuiz(requestParameters: QuizApiApiQuizApiDeleteQuizRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiDeleteQuiz(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiDismissQuizAuditFindingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiDismissQuizAuditFinding(requestParameters: QuizApiApiQuizApiDismissQuizAuditFindingRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiDismissQuizAuditFinding(requestParameters.auditId, requestParameters.key, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiExtendQuizDeadlineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiExtendQuizDeadline(requestParameters: QuizApiApiQuizApiExtendQuizDeadlineRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiExtendQuizDeadline(requestParameters.quizId, requestParameters.extendQuizDeadlineBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiGetGenerationJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiGetGenerationJob(requestParameters: QuizApiApiQuizApiGetGenerationJobRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiGetGenerationJob(requestParameters.jobId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiGetQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiGetQuiz(requestParameters: QuizApiApiQuizApiGetQuizRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiGetQuiz(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiGetQuizAuditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiGetQuizAudit(requestParameters: QuizApiApiQuizApiGetQuizAuditRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiGetQuizAudit(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiGetQuizSolutionCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiGetQuizSolutionCheck(requestParameters: QuizApiApiQuizApiGetQuizSolutionCheckRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiGetQuizSolutionCheck(requestParameters.quizId, requestParameters.submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiListQuizCodingLanguages(options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiListQuizCodingLanguages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiListQuizzesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiListQuizzes(requestParameters: QuizApiApiQuizApiListQuizzesRequest = {}, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiListQuizzes(requestParameters.classId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, requestParameters.tab, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiListTopicsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiListTopics(requestParameters: QuizApiApiQuizApiListTopicsRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiListTopics(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiPublishQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiPublishQuiz(requestParameters: QuizApiApiQuizApiPublishQuizRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiPublishQuiz(requestParameters.quizId, requestParameters.publishQuizBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiQuizOwnerChoicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiQuizOwnerChoices(requestParameters: QuizApiApiQuizApiQuizOwnerChoicesRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiQuizOwnerChoices(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiReorderQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiReorderQuestions(requestParameters: QuizApiApiQuizApiReorderQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiReorderQuestions(requestParameters.quizId, requestParameters.reorderQuizQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiSaveQuizPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiSaveQuizPlan(requestParameters: QuizApiApiQuizApiSaveQuizPlanRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiSaveQuizPlan(requestParameters.quizId, requestParameters.quizPlanBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiSendQuizChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiSendQuizChat(requestParameters: QuizApiApiQuizApiSendQuizChatRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiSendQuizChat(requestParameters.quizId, requestParameters.quizChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiStartAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiStartAnalysis(requestParameters: QuizApiApiQuizApiStartAnalysisRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiStartAnalysis(requestParameters.quizId, requestParameters.startAnalysisBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiStartGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiStartGeneration(requestParameters: QuizApiApiQuizApiStartGenerationRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiStartGeneration(requestParameters.quizId, requestParameters.startGenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiStartQuizAuditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiStartQuizAudit(requestParameters: QuizApiApiQuizApiStartQuizAuditRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiStartQuizAudit(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiSuggestQuizTopicsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiSuggestQuizTopics(requestParameters: QuizApiApiQuizApiSuggestQuizTopicsRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiSuggestQuizTopics(requestParameters.quizId, requestParameters.quizTopicsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiTransferQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiTransferQuiz(requestParameters: QuizApiApiQuizApiTransferQuizRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiTransferQuiz(requestParameters.quizId, requestParameters.transferQuizBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiUndoQuizAuditFindingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiUndoQuizAuditFinding(requestParameters: QuizApiApiQuizApiUndoQuizAuditFindingRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiUndoQuizAuditFinding(requestParameters.auditId, requestParameters.key, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiUndoQuizChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiUndoQuizChat(requestParameters: QuizApiApiQuizApiUndoQuizChatRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiUndoQuizChat(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiUpdateQuestion(requestParameters: QuizApiApiQuizApiUpdateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiUpdateQuestion(requestParameters.questionId, requestParameters.quizId, requestParameters.updateQuizQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiUpdateQuizRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiUpdateQuiz(requestParameters: QuizApiApiQuizApiUpdateQuizRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiUpdateQuiz(requestParameters.quizId, requestParameters.updateQuizBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizApiApiQuizApiUpdateTopicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizApiUpdateTopic(requestParameters: QuizApiApiQuizApiUpdateTopicRequest, options?: RawAxiosRequestConfig) {
        return QuizApiApiFp(this.configuration).quizApiUpdateTopic(requestParameters.quizId, requestParameters.topicId, requestParameters.updateTopicBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const QuizApiListQuizzesStatusEnum = {
    Draft: 'Draft',
    Generating: 'Generating',
    Ready: 'Ready',
    Published: 'Published',
} as const;
export type QuizApiListQuizzesStatusEnum = typeof QuizApiListQuizzesStatusEnum[keyof typeof QuizApiListQuizzesStatusEnum];
export const QuizApiListQuizzesTabEnum = {
    All: 'all',
    Drafts: 'drafts',
    Scheduled: 'scheduled',
    Open: 'open',
    Closed: 'closed',
} as const;
export type QuizApiListQuizzesTabEnum = typeof QuizApiListQuizzesTabEnum[keyof typeof QuizApiListQuizzesTabEnum];
